export const API_URL = "https://tholeo.fr/wp-json/akyos/v1";

export const markerCustom =
  "https://tholeo.fr/app/themes/akyos-sage/resources/assets/js/Map/utils/marker.svg";
